import { call, put, select, takeEvery } from '@redux-saga/core/effects';
import { ActionType } from 'typesafe-actions';
import { LoginData } from '../../../account/login/models/authModel';
import {
  cookieStorage,
  COOKIE_ACCESS_TOKEN
} from '../../../account/login/service/cookie';
import * as Actions from '../actions/controlGpAction';
import { controlGpApi } from '../apis/controlGpApi';
import decode from 'jwt-decode';
import { ControlGpData } from '../models/controlGpModel';
import { detail } from '../../../analysis/history/actions/analysisHistoryAction';
import { useSelector } from 'react-redux';

const token = cookieStorage.getCookie(COOKIE_ACCESS_TOKEN);

function* getControlGpSaga(
  action: ActionType<typeof Actions.controlGpAction.request>
) {
  try {
    const data = action.payload;

    const state = yield select();
    const { objectId, isClickObject } = state.controlMapReducer;
    //  그룹 별 기체 필터링
    const { controlGroupAuthInfo } = state.controlGpState;
    const { controlGpHistory } = state.controlGpHisState;

    // let gpsData: ControlGpData[] = [];

    //사용자가 등록한 기체(식별장치 포함)만 관제에서 볼 수 있게 필터처리
    // if (controlGroupAuthInfo?.length > 0) {
    //   controlGroupAuthInfo.forEach(auth => {
    //     if (gpsData.length > 0) return false;

    //     // gpsData = data.filter(gps => auth.idntfNum === gps.objectId);
    //   });
    // }

    let res;

    if (token && data.length > 0) {
      const user = decode<LoginData>(token);
      res = yield call(controlGpApi.getGroupAuth, user.cstmrSno);
    }

    yield put(
      Actions.controlGpAction.success({
        // controlGpList: gpsData
        controlGpList: data,
        controlGroupAuthInfo: res || []
      })
    );

    if (data.length > 0) {
      const controlIds: any = [];

      data.forEach(gps => {
        if (gps.controlId && gps.objectId.substring(0, 2) === 'PA') {
          const arcrft = controlGroupAuthInfo?.find(
            auth => auth.idntfNum === gps.objectId
          );

          if (arcrft) controlIds.push(gps.controlId);
        }
      });

      const param = controlIds.join(',');
      const obj = {
        cntrlId: param
      };

      const rs = yield call(controlGpApi.getArcrftWarnList, obj);

      yield put(Actions.controlGpArcrftWarnAction.success(rs));
    }

    if (objectId) {
      let detailData;

      //상세 정보에서 실시간 데이터 호출
      //*
      data.map(item => {
        if (item.controlId === objectId) {
          detailData = item;
        }
      });

      yield put(Actions.controlGpRtDtlAction.request(detailData));
    }
  } catch (error) {
    yield put(Actions.controlGpAction.failure(error));
  }
}

function* getControlGpHistorySaga(
  action: ActionType<typeof Actions.controlGpHisAction.request>
) {
  try {
    const { id } = action.payload;

    const data = yield call(controlGpApi.getHistory, id);

    yield put(
      Actions.controlGpHisAction.success({
        controlGpHistory: data
      })
    );
  } catch (error) {
    yield put(Actions.controlGpHisAction.failure(error));
  }
}

function* controlGpRtDtlSaga(
  action: ActionType<typeof Actions.controlGpRtDtlAction.request>
) {
  try {
    const controlGpDetail = action.payload;
    // console.log(controlGpDetail);
    yield put(
      Actions.controlGpRtDtlAction.success({
        controlWheather: undefined,
        controlDetail: undefined,
        controlGpDetail: controlGpDetail
      })
    );
  } catch (error) {
    yield put(Actions.controlGpRtDtlAction.failure(error));
  }
}

function* controlDtlSaga(
  action: ActionType<typeof Actions.controlGpDtlAction.request>
) {
  try {
    const controlId = action.payload;
    const state = yield select();
    const { controlGpList } = state.controlGpState;
    const adress = controlGpList.filter(i => i.controlId === controlId);
    const lat = adress[0].lat;
    const lng = adress[0].lng;

    const rq = {
      nx: lat, // 위도
      ny: lng
    };
    //날씨 api 호출
    const res = yield call(controlGpApi.apiweather, rq);
    const { data } = yield call(controlGpApi.getDetail, controlId);

    yield put(
      Actions.controlGpDtlAction.success({
        ...data,
        res,
        items: res.response.body.items
      })
    );
  } catch (error) {
    yield put(Actions.controlGpDtlAction.failure(error));
  }
}

// function* controlGroupAuthSaga(
//   action: ActionType<typeof Actions.controlGroupAuthAction.request>
// ) {
//   const token = cookieStorage.getCookie(COOKIE_ACCESS_TOKEN);

//   try {
//     if (token) {
//       const user = decode<LoginData>(token);
//       const data = yield call(controlGpApi.getGroupAuth, user.cstmrSno);

//       yield put(
//         Actions.controlGroupAuthAction.success({
//           controlGroupAuthInfo: data
//         })
//       );
//     }
//   } catch (error) {
//     yield put(Actions.controlGroupAuthAction.failure(error));
//   }
// }

function* controlGpFlightPlanSaga(
  action: ActionType<typeof Actions.controlGpFlightPlanAction.request>
) {
  try {
    const idntfNum = action.payload;
    const list = yield call(controlGpApi.getFlightPlan, idntfNum);

    yield put(Actions.controlGpFlightPlanAction.success(list));
  } catch (error) {
    yield put(Actions.controlGpFlightPlanAction.failure(error));
  }
}

function* getControlGpWarnLogSaga(
  action: ActionType<typeof Actions.controlGpLogAction.request>
) {
  try {
    const { id } = action.payload;
    const data = yield call(controlGpApi.getWarnLog, id);
    yield put(Actions.controlGpLogAction.success(data));
  } catch (error) {
    yield put(Actions.controlGpLogAction.failure(error));
  }
}

function* ControlWeatherSaga(
  action: ActionType<typeof Actions.controlweatherAction.request>
) {
  try {
    const rq = action.payload;
    const res = yield call(controlGpApi.apiweather, rq);
    yield put(
      Actions.controlweatherAction.success({
        items: res.response.body.items
      })
    );
  } catch (error) {
    yield put(Actions.controlweatherAction.failure(error));
  }
}
function* controlGpFlightPlanWarnSaga(
  action: ActionType<typeof Actions.controlGpFlightPlanWarnAction.request>
) {
  try {
    const idntfNum = action.payload;

    const rs = yield call(controlGpApi.checkPlanContains, idntfNum);

    yield put(Actions.controlGpFlightPlanWarnAction.success(rs));
  } catch (error) {
    yield put(Actions.controlGpFlightPlanWarnAction.failure(error));
  }
}

function* controlGpArcrftWarnSaga(
  action: ActionType<typeof Actions.controlGpArcrftWarnAction.request>
) {
  try {
    const id = action.payload;

    const rs = yield call(controlGpApi.getArcrftWarnList, id);

    yield put(Actions.controlGpArcrftWarnAction.success(rs));
  } catch (error) {
    yield put(Actions.controlGpArcrftWarnAction.failure(error));
  }
}

function* controlGpCountSaga(
  action: ActionType<typeof Actions.controlGpCountAction.request>
) {
  try {
    const data = action.payload;
    yield put(Actions.controlGpCountAction.success(data));
  } catch (error) {
    yield put(Actions.controlGpCountAction.failure(error));
  }
}

export function* controlGpSaga() {
  yield takeEvery(Actions.controlGpAction.request, getControlGpSaga);
  yield takeEvery(Actions.controlGpHisAction.request, getControlGpHistorySaga);
  yield takeEvery(Actions.controlGpLogAction.request, getControlGpWarnLogSaga);
  yield takeEvery(Actions.controlGpRtDtlAction.request, controlGpRtDtlSaga);
  yield takeEvery(Actions.controlGpDtlAction.request, controlDtlSaga);
  // yield takeEvery(Actions.controlGroupAuthAction.request, controlGroupAuthSaga);
  yield takeEvery(Actions.controlweatherAction.request, ControlWeatherSaga);

  yield takeEvery(
    Actions.controlGpFlightPlanAction.request,
    controlGpFlightPlanSaga
  );
  yield takeEvery(
    Actions.controlGpFlightPlanWarnAction.request,
    controlGpFlightPlanWarnSaga
  );
  yield takeEvery(
    Actions.controlGpArcrftWarnAction.request,
    controlGpArcrftWarnSaga
  );
  yield takeEvery(Actions.controlGpCountAction.request, controlGpCountSaga);
}
